export { ResolveRequest, ResolveResponse, Context, Context_ContextEntry, Fetch_Type, } from './spotify/rcs/resolver/grpc/v0/resolver_service';
export { UserInfo } from './spotify/net/rpc/metadata/userinfo/user_info';
//# sourceMappingURL=proto.js.map